import Flickity from "flickity"
import {getElement, getElements} from "./utils/getElement";

const initSliders = () => {
    const sliders = getElements('.js-slider')
    const screenshotSlider = getElement('.js-slider-screenshot')
    const gallerySlider = getElements('.wp-block-gallery.is-style-slider')

    if (sliders.length) {
        sliders.map(slider => {
            new Flickity(slider, {
                cellAlign: 'center',
                contain: true,
                imagesLoaded: true,
                prevNextButtons: false,
                adaptiveHeight: true
            });
        })
    }

    if (screenshotSlider) {
        const screenshotSliderObj = new Flickity(screenshotSlider, {
            cellAlign: 'center',
            contain: true,
            imagesLoaded: true,
            prevNextButtons: true,
            pageDots: false,
            wrapAround: true,
            adaptiveHeight: true
        });

        screenshotSliderObj.on( 'ready', () => {
            screenshotSliderObj.resize()
        });

        setTimeout(() => {
            screenshotSliderObj.resize();
        }, 2000)
    }

    if (gallerySlider) {
        gallerySlider.map((slider) => {
            new Flickity(slider, {
                cellAlign: 'left',
                contain: false,
                imagesLoaded: true,
                prevNextButtons: true,
                pageDots: true,
                wrapAround: true,
                adaptiveHeight: true
            });
        })
    }
}

export {initSliders}
